import ButtonSecondary from "@/shared/Button/ButtonSecondary";

const OrderCanceled = () => {
  return (
    <div className="container">
      <div className="mx-auto flex max-w-2xl flex-col items-center justify-center gap-5 py-24">
        <h1
          className="text-[100px] font-extrabold text-primary"
          style={{ lineHeight: "1em" }}
        >
          &nbsp;
        </h1>
        <h4 className="text-4xl font-semibold">Order Canceled</h4>
        <div className="flex items-center justify-center gap-5">
          <ButtonSecondary
            href="/"
            className="border-2 border-primary text-primary"
          >
            Go Home
          </ButtonSecondary>
        </div>
      </div>
    </div>
  );
};

export default OrderCanceled;
